// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: 'a67197654',
  buildTime: '2026-11-05T14:19:48.628Z',
} as const;
